// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumb_breadcrumbs__OVefH","home_icon_holder":"Breadcrumb_home_icon_holder__sBP_r","home_icon":"Breadcrumb_home_icon__8_vvt"};